// extracted by mini-css-extract-plugin
export var outerGbiContainer = "index-module--outerGbiContainer--6sQq7";